import axiosInstance from '../../axios/instance'
import { normalizeToUTC } from '@revbox/helpers-fe'
import { endOfDay, startOfDay, subDays } from 'date-fns'
import { getToken } from '../../helpers/get-token'

async function getPeriodIntervalAuctions({ search = '', page = 1 } = {}, campaignId, intervalType = 6) {
    try {
        const currentPeriod = [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())]

        const previousPeriod = [startOfDay(subDays(new Date(), 60)), endOfDay(subDays(new Date(), 30))]

        const token = getToken()
        axiosInstance.defaults.headers.common['authorization'] = token

        // should be number[]
        const interval_type = Array.isArray(intervalType) ? intervalType : [Number(intervalType)]

        const response = await axiosInstance.post(
            process.env.REACT_APP_HUB_URL + '/api/analytics/campaign/period/interval-auctions?page=' + page + '&search=' + search,
            {
                current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
                previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
                campaign_id: Number(campaignId),
                interval_types: interval_type
            }
        )
        return response?.data
    } catch (error) {
        console.log(error)
    }
}

export default getPeriodIntervalAuctions
